export default process.env.NODE_ENV === 'production' ? 'https://poze-sector3.verdedata.ro' : 'http://localhost:9033'
